import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import request from '../../../utils/Request.utils';

const ConsultWrite = () => {
  console.log('ConsultWrite')
  const navigate = useNavigate();
  const { consu_seq } = useParams();
  console.log(consu_seq)
  const [inquiryDate, setInquiryDate] = useState("");
  const [consuStatList, setConsuStatList] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState('');

  const [name, setName] = useState("");
  const [corp, setCorp] = useState("");
  const [tel, setTel] = useState("");
  const [memo, setMemo] = useState("");



  const getConsuStat = () => {
    let params = {};

    const successHandler = (response) => {
      if (response.messageCode === 200) {
        setConsuStatList(response.data.data_list);
      } else {
        console.log("문의 유형정보를 불러올 수 없습니다.");
        toast.error("문의 유형정보를 불러올 수 없습니다.");
      }
    };
    const failHandler = (error) => {
      console.log(error);
    };

    request.get("/common/code/consu_stat", params, successHandler, failHandler);
  };

  useEffect(() => {
    if (consu_seq) {
      const fetchInquiryData = async () => {
        try {
          const successHandler = (response) => {
            const data = response.data;
            setInquiryDate(data.reg_dtm);
            setSelectedStatus(data.consu_stat)
            setName(data.consu_name || "");
            setCorp(data.consu_corp || "");
            setTel(data.consu_tel || "");
            setMemo(data.manger_memo || "");
          };

          const errorHandler = (error) => {
            toast.error("문의 불러오기 중 오류가 발생했습니다.");
          };

          await request.get(`/board/list/admin/consult/${consu_seq}`, {}, successHandler, errorHandler);
        } catch (error) {
          toast.error("문의 불러오기 중 오류가 발생했습니다.");
        }
      };

      fetchInquiryData();
      getConsuStat();
    }
  }, [consu_seq]);

  const handleMemoChange = (e) => setMemo(e.target.value);



  const handleSubmit = async () => {
    const formData = {
      consu_stat: selectedStatus,
      manger_memo: memo
    };

    try {
      const successHandler = (response) => {
        console.log('메모 답변등록 response', response)
        if (response.messageCode === 200) {
          toast.success(`메모가 성공적으로 ${consu_seq ? "수정" : "등록"}되었습니다.`);
          navigate("/Manage/Consult");
        } else if (response.messageCode === 411) {
          toast.error(`메모 ${consu_seq ? "수정" : "등록"} 내용이 없습니다.`);
        } else {
          toast.error(`메모 ${consu_seq ? "수정" : "등록"} 중 오류가 발생했습니다.`);
        }
      };

      const errorHandler = (error) => {
        toast.error(`문의 ${consu_seq ? "수정" : "등록"} 중 오류가 발생했습니다.`);
      };

      if (consu_seq) {
        await request.put(`/board/consult/${consu_seq}`, formData, successHandler, errorHandler);
      } else {
        await request.post("/board/consult", formData, successHandler, errorHandler);
      }

    } catch (error) {
      toast.error(`문의 ${consu_seq ? "수정" : "등록"} 중 오류가 발생했습니다.`);
    }
  };

  const handleStatusChange = (e) => {
    setSelectedStatus(e.target.value);
  };

  return (
    <main>
      <h2 className="adm_com_pg_tit">문의 {consu_seq ? "수정" : "등록"}</h2>
      <div className="adm_com_pg_content">
        <table className='adm_com_board_list type_row'>
          <colgroup>
            <col width="10%" /><col />
            <col width="10%" /><col />
          </colgroup>
          <tbody>
            <tr>
              <th>등록일</th>
              <td colSpan={3}>{inquiryDate || "YYYY-MM-DD"}</td>
            </tr>
            <tr>
              <th>처리상태</th>
              <td colSpan={3}>
                <select className="select" value={selectedStatus} onChange={handleStatusChange}>
                  <option value="전체">선택</option>
                  {consuStatList.map((title) => (
                    <option key={title.comm_code} value={title.comm_code}>
                      {title.code_nm}
                    </option>
                  ))}
                </select>
              </td>
            </tr>
            <tr>
              <th>이름</th>
              <td>
                {name}
              </td>
              <th>회사명</th>
              <td>
                {corp}
              </td>
            </tr>
            <tr>
              <th>전화번호</th>
              <td colSpan={3}>{tel}</td>
            </tr>
            <tr>
              <th>상담자</th>
              <td colSpan={3}>관리자</td>
            </tr>
            <tr>
              <th>메모</th>
              <td colSpan={3}>
                <textarea className="textarea" value={memo} onChange={handleMemoChange}></textarea>
              </td>
            </tr>
          </tbody>
        </table>
        <div className="adm_com_btn_wrap center">
          <button className="adm_com_btn blue" onClick={handleSubmit}>{consu_seq ? "수정" : "등록"}</button>
          <button className="adm_com_btn gray" onClick={() => navigate("/Manage/Consult")}>취소</button>
        </div>
      </div>
      <ToastContainer />
    </main>
  );
};

export default ConsultWrite;
